import { render, staticRenderFns } from "./noAuthority.vue?vue&type=template&id=d3708578&scoped=true&"
import script from "./noAuthority.vue?vue&type=script&lang=js&"
export * from "./noAuthority.vue?vue&type=script&lang=js&"
import style0 from "./noAuthority.vue?vue&type=style&index=0&id=d3708578&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3708578",
  null
  
)

export default component.exports